import React from 'react';
import { SimplifyBackground } from "../../constants/ImagePaths";
import { SimplifyImageAboutUs } from "../../constants/ImagePaths";
import Image from '../../components/general/Image';
import Button from '../../components/general/Button';
import { ROUTES } from '../../routes/RouteList';
import { ArrowUpRight } from '../../components/common/Icons';

const SimplifySection = () => {
  const backgroundImage = {
    backgroundImage: `url(${SimplifyBackground})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    zIndex: '2',
  }

  return (
    <section className="-mt-[45px] py-[50px] lg:pb-0" style={backgroundImage}>
    <div className="text-black md:flex lg:justify-between lg:items-end --layout-padding max-width">
      <div className="lg:w-[30%]">
        <figure className='lg:bottom-[25px]'><Image className='w-[100%]' src={SimplifyImageAboutUs} alt=""/></figure>
      </div>
      <div className="content-block mt-[30px] lg:w-[60%]">
        <h4 className='text-[30px] lg:text-[30px] font-semibold md:text-right'>Looking for reliable, high-performing devs? We’ll handpick them for you.</h4>
        <div className="text-end my-[30px]">
          <Button className='btn-outline-white border border-white rounded h-[50px] w-full md:w-[200px] lg:w-[250px] lg:h-[60px] md:ml-auto' href={ROUTES.START_HIRING}>
            <div className="flex items-center justify-center gap-2">
              <span>
                Hire developer now
              </span>  
              <ArrowUpRight className="w-4 h-4" />
            </div>
          </Button>
        </div>
      </div>
    </div>
  </section>
  );
};

export default SimplifySection;